import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M1.75 1a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 0 1.5 0v-4.5A.75.75 0 0 0 1.75 1ZM3 8a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3Zm3 1.5h2v1a.5.5 0 0 0 1 0v-1h2v1a.5.5 0 0 0 1 0v-1h1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h2v2a.5.5 0 0 0 1 0v-2Zm7.5-7.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5Zm-9.75 1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM7 4a.75.75 0 1 1 1.5 0A.75.75 0 0 1 7 4Zm4.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z';
const draw24px =
  'M2 3.75a.75.75 0 0 1 1.5 0v6.5a.75.75 0 0 1-1.5 0v-6.5ZM2 14a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5Zm6-.5v3a.5.5 0 0 1-1 0v-3H4a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-3v1a.5.5 0 0 1-1 0v-1h-2v2a.5.5 0 0 1-1 0v-2h-2v2a.5.5 0 0 1-1 0v-2H8ZM21.25 3a.75.75 0 0 0-.75.75v6.5a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-.75-.75ZM5.75 6.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM8 7a.75.75 0 1 1 1.5 0A.75.75 0 0 1 8 7Zm3.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM14 7a.75.75 0 1 1 1.5 0A.75.75 0 0 1 14 7Zm3.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const QuickDistanceIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'quickDistance')) as IconWithRender;

QuickDistanceIcon.displayName = 'QuickDistanceIcon';
QuickDistanceIcon.propTypes = Icon.propTypes;
QuickDistanceIcon.renderIcon = (props) => <QuickDistanceIcon {...props} />;
export default QuickDistanceIcon;
